<template lang="html">
    <div id="parentx">
        <vs-sidebar default-index="1" :parent="parent" :hiddenBackground="doNotClose" class="sidebarx"
                    spacer v-model="isSidebarActive" :click-not-close="doNotClose">
            <div class="header-sidebar text-center" slot="header">
                <img :src="logo" alt="Logo"/>
                <h4>Beállítások</h4>
            </div>
            <vs-sidebar-item index="1" to="/dashboard/items">
                Étlap cikkek
            </vs-sidebar-item>
            <vs-sidebar-item index="2" to="/dashboard/dailymenuitems">
                Menü cikkek
            </vs-sidebar-item>
            <vs-sidebar-item index="3" to="/dashboard/dailymenu">
                Napi menük felvitele
            </vs-sidebar-item>
            <vs-sidebar-item index="4" to="/dashboard/orders">
                Rendelések
            </vs-sidebar-item>
          <vs-sidebar-item index="5" to="/dashboard/itemoptions">
            Étlap / menü beállítások
          </vs-sidebar-item>
          <vs-sidebar-item index="6" to="/dashboard/orderoptions">
            Megrendelés beállítások
          </vs-sidebar-item>
          <vs-divider></vs-divider>
          <vs-sidebar-item index="7" @click="logout()">
            Kilépés
          </vs-sidebar-item>
        </vs-sidebar>
    </div>
</template>

<script>
    import router from "@/router";

    export default {
        name: "SideBar",
        props: {
            parent: {
                type: String
            },
            index: {
                default: null,
                type: [String, Number]
            },
            logo: {
                type: String
            }
        },
        data: () => ({
            doNotClose: false,
            windowWidth: window.innerWidth,
        }),
        computed: {
            isSidebarActive: {
                get() {
                    return this.$store.state.isSidebarActive
                },
                set(val) {
                    this.$store.commit('IS_SIDEBAR_ACTIVE', val)
                }
            },
        },
        watch: {},
        methods: {
            handleWindowResize(event) {
                this.windowWidth = event.currentTarget.innerWidth;
                this.setSidebar();
            },
            setSidebar() {
                if (this.windowWidth < 1170) {
                    this.$store.commit('IS_SIDEBAR_ACTIVE', false);
                    this.doNotClose = false
                } else {
                    this.$store.commit('IS_SIDEBAR_ACTIVE', true);
                    this.doNotClose = true
                }
            },
          logout() {
            this.$store.commit('logoutUser');
            router.push('/admin');
          }
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.handleWindowResize);
            });
            this.setSidebar();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.handleWindowResize);
            this.setSidebar();
        },
    }
</script>
<style>
    .vs-sidebar, .vs-sidebar-primary, .vs-sidebar-parent {
        background: rgba(249, 240, 223, 0.85);
        box-shadow: 0 0 5px 1px #000;
    }

    .vs-sidebar--items {
        background-color: transparent;
        transition: 0.2s all linear;
    }

    .vs-sidebar--item:hover {
        background-color: rgba(83, 42, 40, 0.25);
    }

    .router-link-exact-active {
        background-color: rgba(83, 42, 40, 0.25);
    }

    .header-sidebar img {
        height: 65px;
        margin-bottom: 5px;
    }

    @media (max-width: 1170px) {
        .vs-sidebar, .vs-sidebar-primary, .vs-sidebar-parent {
            background: rgba(249, 240, 223, 1);
        }
    }
</style>